import { defineComponent as _defineComponent } from 'vue'
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import api from '@sh/services/api/shared.js';
import session from '@sh/services/session';
import { User } from '@sh/types';
import { onMounted } from 'vue';

interface Props {
  collapsed: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarCard.ts',
  props: {
    collapsed: { type: Boolean }
  },
  setup(__props: any) {



const domWindow = window as typeof window & { dataLayer: any[]; user?: User; Beacon: Function };

async function openHelloNext() {
  const user = session.getUser();
  if (!user) return;

  const { token } = await api.auth.generateHelloNextToken(user);
  window.open(`https://roadmap.theoptimizer.io/?sso_token=${token}`, '_blank');
}

function toggleSupportChat() {
  if (!domWindow.Beacon) return;
  domWindow?.Beacon('toggle');
}

onMounted(() => {
  if (domWindow.dataLayer && process.env.NODE_ENV === 'production') {
    domWindow.dataLayer.push({ event: 'hellonext_button' });
  }
  if (domWindow.Beacon) {
    domWindow.Beacon('config', {
      display: {
        style: 'manual',
      },
    });
  }
});

return { __sfc: true,domWindow, openHelloNext, toggleSupportChat, OptimizerIconV2, session }
}

})